import { render, staticRenderFns } from "./SpecialistPatientsStudents.vue?vue&type=template&id=051ce0a5&scoped=true&"
import script from "./SpecialistPatientsStudents.vue?vue&type=script&lang=js&"
export * from "./SpecialistPatientsStudents.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistPatientsStudents.vue?vue&type=style&index=0&id=051ce0a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ce0a5",
  null
  
)

export default component.exports